var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.title,"tabindex":"0"}},[_c('b-button',{class:_vm.buttonClass,attrs:{"variant":_vm.variant,"disabled":""}},[_vm._v("Delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }